import { Modal, Card, List, Checkbox } from 'antd'
import { useEffect, useState } from 'react'
import QueryBuilderCommands from 'Dummy/queryCommands'
import './WeaverQueryHelperModal.scss'
CheckboxGroup = Checkbox.Group

export default WeaverQueryHelperModal = ({ queryType, visible, setVisible }) ->

  SparqlCommands = [
    {
      command: "SPARQL"
      info: <p>SPARQL is a query language. For information on how to write queries using SPARQL
        visit <a href='https://www.w3.org/TR/sparql11-query/'>sparql documentation</a></p>
      syntax: ""
      usage: """SELECT DISTINCT ?node
        WHERE {
          ?node ?p ?o .
        }
      """
    }
  ]

  dataSource = if queryType is 'QueryBuilder' then QueryBuilderCommands else SparqlCommands

  if queryType is 'QueryBuilder'
    options = []
    for source in dataSource
      if source.type not in options
        options.push(source.type)

    [filters, setFilters] = useState(options or undefined)

  <Modal
    visible={visible}
    onCancel={ -> setVisible(false)}
    centered={true}
    width={Math.max(800, window.innerWidth / 2)}
    footer={<div />}
    style={
      marginTop: '3vh'
    }
    bodyStyle={{
      maxHeight: '82vh'
      overflow: 'auto'
    }}
    title="Query Builder Helper"
    className="weaver-query-helper"
  >
    {
      if queryType is 'QueryBuilder'
        <CheckboxGroup
          label='Filter options'
          options={options}
          disabled={false}
          defaultValue={filters}
          onChange={setFilters}
        />
    }
    <List
      className="list"
      dataSource={dataSource}
      renderItem={(item) =>
        (
          if !filters? or item.type in filters
            <Card className="command-card">
              <List.Item
                key={item.command}
                style={{display: 'inline'}}
                extra={<span className='snippet'><code>{item.usage}</code></span>}
              >
                <List.Item.Meta
                  title={<b>{item.command}</b>}
                  description={<p style={{float: 'right'}}>{item.syntax}</p>}
                />
                  <div className="content">
                    {item.info}
                  </div>
              </List.Item>
            </Card>
        )
      }
    />
  </Modal>
